import { useLayoutEffect, useRef, useState } from "react";

/**
 * Måler tilgjengelig høyde på et element og regner ut hvor mange rader à
 * `radPx` som får plass – slik at lister fyller en fast rute uten å scrolle.
 * Oppdateres via ResizeObserver når ruten endrer størrelse.
 */
export function useFitCount(radPx: number) {
  const ref = useRef<HTMLDivElement>(null);
  const [antall, setAntall] = useState(6);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const regn = () => {
      const h = el.clientHeight;
      if (h > 0) setAntall(Math.max(1, Math.floor(h / radPx)));
    };
    regn();
    const ro = new ResizeObserver(regn);
    ro.observe(el);
    return () => ro.disconnect();
  }, [radPx]);

  return [ref, antall] as const;
}
